"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRestrictionsLevel = exports.getProjectLinks = exports.getPopulatedCurrentQuerySettings = exports.getFlowBreadcrumbs = exports.getFilteredCurrentProjectForDesign = exports.getFilteredCurrentProjectForDeploy = exports.getDeploymentById = exports.getDeploymentBreadcrumbs = exports.getCurrentSurveyHandles = exports.getCurrentSurvey = exports.getCurrentQueryName = exports.getCurrentQueryAssignmentSurveys = exports.getCurrentQueryAssignmentId = exports.getCurrentQueryAssignmentDeployments = exports.getCurrentQueryAssignmentActiveSurveys = exports.getCurrentQueryAssignmentActiveDeployments = exports.getCurrentProjectVisibleDeploymentIds = exports.getCurrentProjectQueries = exports.getCurrentProjectFields = exports.getCurrentProjectExportData = exports.getCurrentProjectDeployments = exports.getCurrentProjectAssignments = exports.getCurrentProjectActiveAssignments = exports.getCurrentProject = exports.getCurrentDeployments = exports.getCurrentDeploymentSurveys = exports.getCurrentDeploymentIds = exports.getCurrentDeployment = exports.getCurrentAssignmentSurveys = exports.getCurrentAssignmentId = exports.getCurrentAssignmentDeployments = exports.getCurrentAssignment = exports.getAvailableTags = void 0;
var _reselect = require("reselect");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _combineQueries = _interopRequireDefault(require("./combineQueries.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var getOrganizationList = function getOrganizationList(state) {
  return state.organizationList;
};
var getProjectList = function getProjectList(state) {
  return state.projectList;
};
var getCurrentProjectId = function getCurrentProjectId(state) {
  return state.currentProjectId;
};
var getCurrentAssignmentId = exports.getCurrentAssignmentId = function getCurrentAssignmentId(state) {
  return state.currentAssignmentId;
};
var getCurrentQueryAssignmentId = exports.getCurrentQueryAssignmentId = function getCurrentQueryAssignmentId(state) {
  return state.currentQuerySettings.assignmentId;
};
var getCurrentQuerySettings = function getCurrentQuerySettings(state) {
  return state.currentQuerySettings;
};
var getCurrentDeploymentId = function getCurrentDeploymentId(state) {
  return state.currentDeploymentId;
};
var getCurrentDeploymentIds = exports.getCurrentDeploymentIds = function getCurrentDeploymentIds(state) {
  return state.currentDeploymentIds;
};
var getCurrentSurveyId = function getCurrentSurveyId(state) {
  return state.currentSurveyId;
};
var getCurrentSurveyHandles = exports.getCurrentSurveyHandles = function getCurrentSurveyHandles(state) {
  return state.currentSurveyHandles;
};
var getCurrentSurveyListHandles = function getCurrentSurveyListHandles(state) {
  return state.currentSurveyListHandles;
};
var getFlowId = function getFlowId(state, props) {
  return Number(props.match.params.flowId);
};
var getDesignFilter = function getDesignFilter(state) {
  return state.designFilter;
};
var getDeployFilter = function getDeployFilter(state) {
  return state.deployFilter;
};
var getCurrentQueryId = function getCurrentQueryId(state) {
  return state.currentQueryId;
};
var getQueryList = function getQueryList(state) {
  return state.queryList;
};
var getQueryTagFilter = function getQueryTagFilter(state) {
  return state.queryTagFilter;
};
var getVisibleDeploymentIds = function getVisibleDeploymentIds(state) {
  return state.visibleDeploymentIds;
};
var getCurrentProject = exports.getCurrentProject = (0, _reselect.createSelector)(getProjectList, getCurrentProjectId, getCurrentSurveyListHandles, function (projectList, currentProjectId) {
  var currentSurveyListHandles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = projectList.find(function (project) {
    return project.groupId === currentProjectId;
  });
  if (!result) {
    return null;
  }
  if (!result.flows) {
    return result;
  }
  result.flows.assignmentList = result.flows.assignmentList.map(function (assignment) {
    if (!assignment.surveylistList) {
      return assignment;
    }
    var currentSurveylistList = currentSurveyListHandles[assignment.assignmentId] ? assignment.surveylistList.find(function (item) {
      return item.surveylistHandle === currentSurveyListHandles[assignment.assignmentId];
    }) : assignment.surveylistList[0];
    return _objectSpread(_objectSpread({}, assignment), {}, {
      currentSurveylistList: currentSurveylistList
    });
  });

  // we need shallow copy here just to update connected components
  return _objectSpread({}, result);
});
var getCurrentQueryName = exports.getCurrentQueryName = (0, _reselect.createSelector)(getCurrentQueryId, getQueryList, function (queryId, list) {
  if (!queryId) {
    return null;
  }
  var query = list.find(function (item) {
    return item.id === queryId;
  });
  return query ? query.name : null;
});
var getFilteredCurrentProjectForDesign = exports.getFilteredCurrentProjectForDesign = (0, _reselect.createSelector)(getCurrentProject, getDesignFilter, function (currentProject, designFilter) {
  if (!designFilter) {
    return currentProject;
  }
  designFilter = designFilter.toUpperCase();
  return _objectSpread(_objectSpread({}, currentProject), {}, {
    flows: {
      assignmentList: currentProject.flows.assignmentList.filter(function (assignment) {
        if (assignment.archived) {
          return false;
        }
        return (assignment.label || '').toUpperCase().includes(designFilter) || (assignment.description || '').toUpperCase().includes(designFilter) || assignment.currentSurveylistList.surveyList.filter(function (survey) {
          return !survey.archived;
        }).some(function (survey) {
          return (survey.label || '').toUpperCase().includes(designFilter) || (survey.description || '').toUpperCase().includes(designFilter);
        });
      })
    }
  });
});
var getFilteredCurrentProjectForDeploy = exports.getFilteredCurrentProjectForDeploy = (0, _reselect.createSelector)(getCurrentProject, getDeployFilter, function (currentProject, deployFilter) {
  if (!deployFilter) {
    return currentProject;
  }
  deployFilter = deployFilter.toUpperCase();
  return _objectSpread(_objectSpread({}, currentProject), {}, {
    flows: {
      assignmentList: currentProject.flows.assignmentList.filter(function (assignment) {
        if (assignment.archived) {
          return false;
        }
        return (assignment.label || '').toUpperCase().includes(deployFilter) || (assignment.description || '').toUpperCase().includes(deployFilter) || assignment.deploymentList.some(function (survey) {
          return (survey.label || '').toUpperCase().includes(deployFilter);
        });
      })
    }
  });
});
var getCurrentProjectAssignments = exports.getCurrentProjectAssignments = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  if (!currentProject || !currentProject.flows) {
    return [];
  }
  return currentProject.flows.assignmentList;
});
var getCurrentProjectActiveAssignments = exports.getCurrentProjectActiveAssignments = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  return assignments.filter(function (item) {
    return !item.archived;
  });
});
var getCurrentProjectDeployments = exports.getCurrentProjectDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  var result = [];
  assignments.forEach(function (item) {
    result.push.apply(result, _toConsumableArray(item.deploymentList));
  });
  return result;
});
var getCurrentProjectVisibleDeploymentIds = exports.getCurrentProjectVisibleDeploymentIds = (0, _reselect.createSelector)(getCurrentProjectDeployments, getVisibleDeploymentIds, function (deployments, visibleDeploymentIds) {
  var deploymentIds = deployments.map(function (obj) {
    return obj.deploymentId;
  });
  if (visibleDeploymentIds) {
    var set = new Set(visibleDeploymentIds);
    return deploymentIds.filter(function (id) {
      return set.has(id);
    });
  }
  return deploymentIds;
});
var getCurrentAssignmentDeployments = exports.getCurrentAssignmentDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (projectAssignments, assignmentId) {
  var result = [];
  projectAssignments.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.assignmentId === assignmentId ? item.deploymentList : []));
  });
  return result;
});
var getCurrentQueryAssignmentDeployments = exports.getCurrentQueryAssignmentDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentQueryAssignmentId, function (projectAssignments, assignmentId) {
  var result = [];
  projectAssignments.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.assignmentId === assignmentId ? item.deploymentList : []));
  });
  return result;
});
var getCurrentQueryAssignmentActiveDeployments = exports.getCurrentQueryAssignmentActiveDeployments = (0, _reselect.createSelector)(getCurrentQueryAssignmentDeployments, getVisibleDeploymentIds, function (deployments, visibleDeploymentIds) {
  if (!visibleDeploymentIds) {
    return deployments.filter(function (item) {
      return !item.archived;
    });
  }
  var set = new Set(visibleDeploymentIds);
  return deployments.filter(function (item) {
    return !item.archived && set.has(item.deploymentId);
  });
});
var getCurrentAssignmentSurveys = exports.getCurrentAssignmentSurveys = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (assignments, assignmentId) {
  var assignment = assignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  var result = [];
  assignment && assignment.surveylistList.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.surveyList));
  });
  return result;
});
var getCurrentQueryAssignmentSurveys = exports.getCurrentQueryAssignmentSurveys = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentQueryAssignmentId, function (assignments, assignmentId) {
  var assignment = assignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  var result = [];
  assignment && assignment.surveylistList.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.surveyList));
  });
  return result;
});
var getCurrentQueryAssignmentActiveSurveys = exports.getCurrentQueryAssignmentActiveSurveys = (0, _reselect.createSelector)(getCurrentQueryAssignmentSurveys, function (surveys) {
  return surveys.filter(function (item) {
    return !item.archived;
  });
});
var getPopulatedCurrentQuerySettings = exports.getPopulatedCurrentQuerySettings = (0, _reselect.createSelector)(getCurrentQuerySettings, getCurrentQueryAssignmentActiveDeployments, getCurrentQueryAssignmentActiveSurveys, getVisibleDeploymentIds, function (currentQuerySettings, deployments, surveys, visibleDeploymentIds) {
  var result = _objectSpread({}, currentQuerySettings);
  if (currentQuerySettings.deploymentIds === 'all') {
    result.deploymentIds = deployments.map(function (item) {
      return item.deploymentId;
    });
  }
  if (currentQuerySettings.surveyHandles === 'all') {
    result.surveyHandles = surveys.map(function (item) {
      return item.surveyHandle;
    });
  }
  if (visibleDeploymentIds) {
    result.deploymentIds = (0, _intersection2["default"])(result.deploymentIds, visibleDeploymentIds);
  }
  result.deployments = deployments.filter(function (item) {
    return result.deploymentIds.includes(item.deploymentId);
  });
  return result;
});
var getDeploymentById = exports.getDeploymentById = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentId, function (deployments, deploymentId) {
  return deployments.find(function (item) {
    return item.deploymentId === deploymentId;
  });
});
var getFlowBreadcrumbs = exports.getFlowBreadcrumbs = (0, _reselect.createSelector)(getCurrentProject, getFlowId, function (currentProject, flowId) {
  try {
    var _iterator = _createForOfIteratorHelper(currentProject.flows.assignmentList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var assignment = _step.value;
        var _iterator2 = _createForOfIteratorHelper(assignment.currentSurveylistList.surveyList),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var survey = _step2.value;
            var _iterator3 = _createForOfIteratorHelper(survey.flowList),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var flow = _step3.value;
                if (flow.flowId === flowId) {
                  return [currentProject.label, assignment.label, survey.label];
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } catch (error) {
    return [];
  }
  return [];
});
var getDeploymentBreadcrumbs = exports.getDeploymentBreadcrumbs = (0, _reselect.createSelector)(getCurrentProject, getCurrentDeploymentId, function (currentProject, deploymentId) {
  try {
    var _iterator4 = _createForOfIteratorHelper(currentProject.flows.assignmentList),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var assignment = _step4.value;
        var _iterator5 = _createForOfIteratorHelper(assignment.deploymentList),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var deployment = _step5.value;
            if (deployment.deploymentId === deploymentId) {
              return [currentProject.label, assignment.label, deployment.label];
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } catch (error) {
    return [];
  }
  return [];
});
var getProjectLinks = exports.getProjectLinks = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  return {
    base: "/quest/".concat(currentProject.groupId),
    design: "/quest/".concat(currentProject.groupId, "/design"),
    deploy: "/quest/".concat(currentProject.groupId, "/deploy")
  };
});
var getCurrentProjectExportData = exports.getCurrentProjectExportData = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  var result = [];
  var _iterator6 = _createForOfIteratorHelper(assignments),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var assignment = _step6.value;
      result.push({
        id: result.length + 1,
        assignmentId: assignment.assignmentId,
        assignment: assignment.label,
        surveyId: 0,
        survey: '(all)'
      });
      var _iterator7 = _createForOfIteratorHelper(assignment.surveylistList),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var surveylistList = _step7.value;
          var _iterator8 = _createForOfIteratorHelper(surveylistList.surveyList),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var survey = _step8.value;
              result.push({
                id: result.length + 1,
                assignmentId: assignment.assignmentId,
                assignment: assignment.label,
                surveyId: survey.surveyId,
                survey: survey.label
              });
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return result;
});
var getCurrentAssignment = exports.getCurrentAssignment = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (assignments, currentAssignmentId) {
  return assignments.find(function (item) {
    return item.assignmentId === currentAssignmentId;
  });
});
var getCurrentDeployment = exports.getCurrentDeployment = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentId, function (deployments, currentDeploymentId) {
  return deployments.find(function (item) {
    return item.deploymentId === currentDeploymentId;
  });
});
var getCurrentDeployments = exports.getCurrentDeployments = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentIds, function (deployments, currentDeploymentIds) {
  return deployments.filter(function (item) {
    return currentDeploymentIds.includes(item.deploymentId);
  });
});
var getCurrentSurvey = exports.getCurrentSurvey = (0, _reselect.createSelector)(getCurrentAssignmentSurveys, getCurrentSurveyId, function (surveys, currentSurveyId) {
  return surveys.find(function (item) {
    return item.surveyId === currentSurveyId;
  });
});
var getCurrentDeploymentSurveys = exports.getCurrentDeploymentSurveys = (0, _reselect.createSelector)(getCurrentAssignmentSurveys, getCurrentDeployment, getCurrentProjectDeployments, function (surveys, deployment, allDeployments) {
  var allowedSurveyHandles = [];
  if (typeof deployment === 'undefined') {
    var _iterator9 = _createForOfIteratorHelper(allDeployments),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var index = _step9.value;
        var d = allDeployments[index];
        var options = (0, _get2["default"])(d, 'settings.options', []);
        var _iterator0 = _createForOfIteratorHelper(options),
          _step0;
        try {
          for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
            var i = _step0.value;
            if (!allowedSurveyHandles.includes(options[i])) {
              allowedSurveyHandles.push(options[i]);
            }
          }
        } catch (err) {
          _iterator0.e(err);
        } finally {
          _iterator0.f();
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  } else {
    allowedSurveyHandles = (0, _get2["default"])(deployment, 'settings.options', []);
  }
  return surveys.filter(function (item) {
    return allowedSurveyHandles.includes(item.surveyHandle);
  });
});
var getCurrentProjectQueries = exports.getCurrentProjectQueries = (0, _reselect.createSelector)(getQueryList, getQueryTagFilter, getCurrentProjectId, function (queryList, queryTagFilter, projectId) {
  var hasIdentifiablePermission = Fortress && Fortress.hasAccess('quest.view_identifiable_data', projectId);
  var hasQueryTagFilter = Boolean(queryTagFilter && queryTagFilter.length > 0);
  var result = queryList.filter(function (query) {
    if (query.projectId !== projectId) {
      return false;
    }
    if (query.settings.showQueryTo === 'withIdentifiable' && !hasIdentifiablePermission) {
      return false;
    }
    if (hasQueryTagFilter) {
      var _query$settings;
      var queryTags = ((_query$settings = query.settings) === null || _query$settings === void 0 ? void 0 : _query$settings.tags) || [];
      if (!queryTags.some(function (tag) {
        return queryTagFilter.includes(tag);
      })) {
        return false;
      }
    }
    return true;
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  if (hasQueryTagFilter && result.length > 1) {
    result.unshift((0, _combineQueries["default"])(result));
  }
  return result;
});
var getAvailableTags = exports.getAvailableTags = (0, _reselect.createSelector)(getCurrentProjectQueries, function (projectQueries) {
  var list = new Set();
  projectQueries.forEach(function (project) {
    var _project$settings;
    (((_project$settings = project.settings) === null || _project$settings === void 0 ? void 0 : _project$settings.tags) || []).forEach(function (tag) {
      list.add(tag);
    });
  });
  return _toConsumableArray(list).sort(function (a, b) {
    return a.localeCompare(b);
  });
});
var getRestrictionsLevel = exports.getRestrictionsLevel = (0, _reselect.createSelector)(getOrganizationList, getCurrentProject, function (organizationList, currentProject) {
  var organization = organizationList.find(function (org) {
    return org.groupId === currentProject.organizationId;
  });
  if (!organization) {
    return 'unlimited';
  }
  var match = {
    Basic: 'basic',
    Premium: 'premium',
    Unlimited: 'unlimited'
  };
  return match[organization.restrictionsLevel] || 'unlimited';
});
var getCurrentProjectFields = exports.getCurrentProjectFields = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  return [1, 2, 3, 4, 5].map(function (num) {
    return {
      path: "fields.field_".concat(num),
      value: currentProject.fields["field_".concat(num)],
      isIdentifiable: Boolean(currentProject.fields["field_".concat(num, "_is_identifiable")])
    };
  }).filter(function (item) {
    return item.value;
  }).reduce(function (obj, item) {
    obj[item.path] = item;
    return obj;
  }, {});
});